import { useTheme } from '../contexts/ThemeContext';

/**
 * Shared hook for theme-aware colors across all pages.
 * Replaces the hardcoded `const C = { bg: '#050505', ... }` pattern.
 */
export const useColors = () => {
  const { colors, theme } = useTheme();

  // Extend base theme colors with derived/extra colors used across pages
  const extended = theme === 'dark' ? {
    bg2: '#0F1420', surface: '#131722', surface2: '#1A2030', surface3: '#20283A',
    amber: '#F59E0B',
    glowP: 'rgba(139,92,246,0.35)', glowC: 'rgba(34,211,238,0.25)',
    glowG: 'rgba(251,191,36,0.35)',
    cardBg: 'rgba(255,255,255,0.03)',
    overlayBg: 'rgba(0,0,0,0.6)',
  } : {
    bg2: '#EFF3F8', surface: '#FFFFFF', surface2: '#F1F5F9', surface3: '#E2E8F0',
    amber: '#D97706',
    glowP: 'rgba(124,58,237,0.15)', glowC: 'rgba(8,145,178,0.12)',
    glowG: 'rgba(217,119,6,0.15)',
    cardBg: 'rgba(0,0,0,0.02)',
    overlayBg: 'rgba(255,255,255,0.6)',
  };

  return { ...colors, ...extended, theme };
};
